import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Banner extends Component {
	constructor(props) {
		super(props);
		this.state = {
			news: []
		};
	}

	formatDate = (dateString) => {
		if (!dateString) return 'N/A';
		const date = new Date(dateString);
		return date.toLocaleDateString('en-US', {
			year: 'numeric',
			month: 'long',
			day: 'numeric'
		});
	};

	fetchNews() {
		const apiUrlNews = 'https://khapa.tagit.pk/api/blog.php?news=home_posts&section=home_banner&limit=5';

		fetch(apiUrlNews)
			.then((response) => response.json())
			.then((data) => {
				if (Array.isArray(data)) {
					this.setState({ news: data });
				} else {
					console.error('Unexpected data format:', data);
				}
			})
			.catch((error) => console.error('Error fetching news:', error));
	}

	componentDidMount() {
		this.fetchNews();
	}

	render() {
		let publicUrl = process.env.PUBLIC_URL + '/';
		const { news } = this.state;

		// Display the first news item in the banner and the rest below
		const firstNews = news.length > 0 ? news[0] : null;
		const otherNews = news.slice(1);

		return (
			<div className="banner-area banner-inner-1 bg-black">
				{/* banner area start */}
				<div className="banner-inner pt-5 go-top">
					<div className="container">
						<div className="row">
							<div className="col-lg-6">
								<div className="thumb after-left-top">
									<img
										src={firstNews ? firstNews.post_image : publicUrl + 'assets/img/banner/1.png'}
										alt={firstNews ? firstNews.title : 'news image'}
										onError={(e) => {
											e.target.onerror = null; // Prevents infinite loop in case default image fails
											e.target.src = `${publicUrl}assets/img/banner/1.png`; // Set default image
										  }}
									/>
								</div>
							</div>
							<div className="col-lg-6 align-self-center">
								<div className="banner-details mt-4 mt-lg-0">
									<div className="post-meta-single">
										<ul>
											<li>
												<Link className="tag-base tag-blue" to={`/cat-news/${firstNews?.category_id}`}>
													{firstNews ? firstNews.category : 'Category'}
												</Link>
											</li>
											<li className="date">
												<i className="fa fa-clock-o" />
												{firstNews ? this.formatDate(firstNews.created_at) : 'Date'}
											</li>
										</ul>
									</div>
									<h2>{firstNews ? firstNews.title : 'ReZoom outage left some people locked out.'}</h2>
									{/* <p>
										{firstNews
											? firstNews.description
											: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'}
									</p> */}
									<Link className="btn btn-blue" to={`/news-details/${firstNews?.id}`}>
										Read More
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* banner area end */}
				<div className="container go-top">
					<div className="row">
						{otherNews.map((item, index) => (
							<div className="col-lg-3 col-sm-6" key={index}>
								<div className="single-post-wrap style-white">
									<div className="thumb">
										<img src={item.post_image || publicUrl + 'assets/img/post/1.png'} 
										alt={item.title ?? 'news image'} 
										onError={(e) => {
											e.target.onerror = null; // Prevents infinite loop in case default image fails
											e.target.src = `${publicUrl}assets/img/post/1.png`; // Set default image
										  }}
										/>
										<Link className={`tag-base tag-${item.tagColor || 'blue'}`} to={`/cat-news/${item.category_id}`}>
											{item.category}
										</Link>
									</div>
									<div className="details">
										<h6 className="title">
											<Link to={`/news-details/${item.id}`}>{item.title}</Link>
										</h6>
										<div className="post-meta-single mt-3">
											<ul>
												<li>
													<i className="fa fa-clock-o" />
													{this.formatDate(item.created_at)}
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		);
	}
}

export default Banner;
